<script lang="ts">
	import type { ICard, ICardShape } from "@xbs/lib-kanban";

	export let cardFields: ICard;
	export let cardShape: ICardShape;

	function getHeaderValues(cardFields: ICard, shape: ICardShape) {
		let values = [];

		if (shape.priority?.show) {
			const priorityValue = shape.priority.values?.find(
				priority => priority.id === cardFields.priority
			);

			if (priorityValue) {
				values.push({
					type: "priority",
					value: priorityValue.label,
					color: priorityValue.color,
				});
			}
		}

		const customFieldsConfig = shape.headerFields;
		if (customFieldsConfig) {
			const customFields = customFieldsConfig.reduce((total, field) => {
				if (cardFields[field.key]) {
					total.push({
						value: cardFields[field.key],
						label: field.label,
						css: field.css,
					});
				}
				return total;
			}, []);
			if (customFields) {
				values.push(...customFields);
			}
		}
		return values;
	}

	$: headerValues = getHeaderValues(cardFields, cardShape);

</script>

<div class="wx-header">
	{#each headerValues as field}
		{#if field.value}
			{#if field.type === 'priority'}
				<div class="wx-field wx-priority" style="color:{field.color};">
					<div
						class="wx-priority-background"
						style="background:{field.color}" />
					<span class="wx-priority-label"> {field.value} </span>
				</div>
			{:else}
				<div class="wx-field {field.css}">
					{#if field?.label}
						<span class="wx-label"> {field.label}: </span>
					{/if}
					<span class="wx-value"> {field.value} </span>
				</div>
			{/if}
		{/if}
	{/each}
</div>

<style>
	.wx-header {
		display: flex;
	}
	.wx-header .wx-field {
		margin-right: 10px;
		line-height: 25px;
		font-size: 14px;
	}
	.wx-field {
		margin-bottom: var(--wx-kanban-card-field-padding);
	}

	.wx-priority {
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;

		padding: 0 10px;
		border-radius: 2px;

		position: relative;
		overflow: hidden;
	}
	.wx-priority-background {
		opacity: 0.2;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.wx-priority-label {
		text-transform: capitalize;
	}

</style>
